import React from 'react';
import { useDispatch } from 'react-redux';
import Icon from "@ant-design/icons";
import { Button, Tooltip } from 'antd';
import CompareIco from '@icons/charts/compare.svg';
import { ActionCellWrapper } from './styled';
import { useAtomValue } from 'jotai';
import { TABLE_MODES, modeAtom } from '../atoms';
import { addTopFilters, quickCompareTopFilters } from '@store/trends/base/actions';
import { scrollToCompareFiltersBar } from '@components/summary-panel/CompareFiltersBar/utils';

const COMPARE_TOP_LIMIT = 10;

function ActionHeader({ column, container }) {
  const mode = useAtomValue(modeAtom);
  const dispatch = useDispatch();

  const handleClick = () => {
    if (mode === TABLE_MODES.compare) {
      dispatch(addTopFilters(column.dimension, container._data.slice(0, COMPARE_TOP_LIMIT)));
    } else {
      dispatch(quickCompareTopFilters(column.dimension, container._data.slice(0, COMPARE_TOP_LIMIT)));
      setTimeout(() => {
        scrollToCompareFiltersBar();
      }, 50);
    }
  };

  return (
    <ActionCellWrapper>
      {mode === TABLE_MODES.filter ? (
        <></>
      ) : (
        <Tooltip placement="right" title="Compare top filters">
          <Button style={{ fontSize: 18, lineHeight: 1, padding: 5 }} type="text" icon={<Icon component={CompareIco} />} onClick={handleClick} />
        </Tooltip>
      )}
    </ActionCellWrapper>
  );
}

export default ActionHeader;
